module.exports = "/_next/static/sounds/doorbell.mp3";